<template>
  <div class="CenterEdit">
    <div class="button-style">
      <el-button class="publicBtn" @click="toUserCenter">取消</el-button>
      <el-button
        class="publicBtn"
        type="primary"
        @click="submitForm('ruleForm')"
        >保存</el-button
      >
    </div>
    <div class="user_avatar">
      <img class="user_img" :src="imgUrl" alt />
      {{ username }}
      <div class="user_town">{{ usertown }}</div>
    </div>
    <div class="form">
      <el-form
        v-if="isWRUser"
        :model="ruleForm"
        ref="ruleForm"
        label-width="47%"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item label="系统编号">
          <div class="info_label">{{ ruleForm.identifyCode }}</div>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="ruleForm.instition" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="contactTel">
          <el-input v-model="ruleForm.contactTel" :disabled="true"></el-input> 
          <!-- <div class="info_label">{{ ruleForm.contactTel }}</div> -->
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>

        <el-form-item label="账号申请时间">
          <div class="info_label">{{ ruleForm.createdAt }}</div>
        </el-form-item>
      </el-form>
      <el-form
        v-else
        :model="ruleForm"
        ref="ruleForm"
        label-width="47%"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item label="系统编号">
          <div class="info_label">{{ ruleForm.identifyCode }}</div>
        </el-form-item>
        <el-form-item label="企业名称(全称)">
          <el-input v-model="ruleForm.instition" :disabled="true"></el-input>
        </el-form-item>
        <!-- <el-form-item label="手机号" prop="signTel">
          <el-input v-model="ruleForm.signTel"></el-input>
        </el-form-item>-->
        <el-form-item label="法定代表人姓名/委派代表姓名">
          <el-input v-model="ruleForm.legalName"></el-input>
        </el-form-item>
        <el-form-item label="法定代表人/委派代表手机号" prop="legalTel">
          <el-input v-model="ruleForm.legalTel"></el-input>
        </el-form-item>
        <el-form-item label="联系人姓名">
          <el-input v-model="ruleForm.contactName"></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="contactTel">
          <el-input v-model="ruleForm.contactTel" ></el-input>
          <!-- <div class="info_label">{{ ruleForm.contactTel }}</div> -->
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>

        <el-form-item label="账号申请时间">
          <div class="info_label">{{ ruleForm.createdAt }}</div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { userDetail, userUpdate } from "common/js/api";
import imgUrl from "@/assets/images/menuIcon/u@2x(1).png";
export default {
  data() {
    return {
      username: "",
      usertown: "湘江基金小镇",
      userCode: "",
      imgUrl,
      ruleForm: {
        identifyCode: "",
        instition: "",
        signTel: "",
        legalTel: "",
        legalName: "",
        contactName: "",
        contactTel: "",
        email: "",
        registedType: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入企业名称(全称)", trigger: "blur" },
          {
            min: 3,
            max: 125,
            message: "长度在 3 到 125 个字符",
            trigger: "blur",
          },
        ],
        signTel: [
          {
            min: 3,
            max: 11,
            message: "长度在 3 到 11 个字符",
            trigger: "blur",
          },
        ],
        legalTel: [
          {
            min: 3,
            max: 11,
            message: "长度在 3 到 11 个字符",
            trigger: "blur",
          },
        ],
        contactTel: [
          {
            min: 3,
            max: 11,
            message: "长度在 3 到 11 个字符",
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: "请输入法定代表人姓名/委派代表姓名",
            trigger: "blur",
          },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        contactname: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "长度在 3 到 20 个字符",
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      isWRUser: false,
    };
  },

  created() {
    // this.userCode = "JG764559";
    this.userCode = this.Cookies.get("identifyCode");
    if (this.userCode.substr(0, 1) == "WR") {
      this.isWRUser = true;
    }
  },

  mounted() {
    this.getUserDetail();
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    async submit() {
      const res = userUpdate(this.ruleForm);

      this.$message({
        message: "用户信息更新成功",
        type: "success",
      });
      this.Cookies.set("institutionName", this.ruleForm.instition);
      setTimeout(() => {
        this.toUserCenter();
      }, 500);
    },

    cancle() {
      this.resetForm("ruleForm");
      this.toUserCenter();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    async getUserDetail() {
      const res = await userDetail(this.userCode);
      if (res.result.registedType == "WR") {
        this.isWRUser = true;
      }
      this.ruleForm = res.result;
      this.username = this.ruleForm.contactName;
      console.log(this.ruleForm);
    },

    toUserCenter() {
      this.$router.push("/UC/Center/UserCenter");
    },
  },
};
</script>
<style lang="scss" scoped>
.CenterEdit {
  width: 100%;
}
.user_avatar {
  display: flex;
  overflow: auto;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 85px;
  position: relative;
  font-size: 24px;
  font-family: AlibabaM;
  color: #191818;
  line-height: 33px;
  .user_img {
    margin-bottom: 10px;
    width: 88px;
    height: 88px;
  }
  .user_town {
    margin-top: 6px;
    background: #e6f9ff;
    border-radius: 15px;
    padding: 4px 21px;
    font-size: 14px;
    font-family: AlibabaM;
    color: #008fff;
    line-height: 20px;
  }
}
.form {
  position: relative;
  z-index: 2;
  margin-top: 60px;
  .el-form-item {
    padding-bottom: 10px;
  }
  ::v-deep .el-form-item__label {
    font-size: 16px;
    font-family: Alibaba;
    color: #5f5f5f;
  }
  ::v-deep  .el-form-item {
    margin-bottom: 18px;
  }
  ::v-deep  .el-input {
    width: 360px;
    height: 38px;
    font-size: 16px;
    font-family: Alibaba;
    text-align: left;
    color: #191818;
    position: relative;
    z-index: 3;
  }
  ::v-deep  .el-form-item__error {
    left: 200px;
  }
  ::v-deep .el-form-item__content {
    padding-left: 40px;
  }
  .info_label {
    font-size: 16px;
    font-family: AlibabaM;
    text-align: left;
    color: #191818;
  }
}

.title {
  font-size: 28px;
  color: #0f1824;
  text-align: center;
  margin-bottom: 40px;
}
.button-style {
  position: absolute;
  z-index: 2001;
  top: 30px;
  right: 20px;
}
</style>
